import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../index";
import { getCourses } from "../../utils/api/courses";

const initialState = {
  courses: [],
};

const slice = createSlice({
  name: "courses",
  initialState,
  reducers: {
    setCourses(state, action) {
      state.courses = action.payload;
    },
  },
});

export default slice.reducer;

/**
 * submit learner form
 * updates the learner details
 */
export function fetchCourses(params) {
  return async () => {
    try {
      const { data } = await getCourses({ getAll: "true" });
      dispatch(slice.actions.setCourses(data?.data));
      return data?.data || null;
    } catch (err) {
      console.log(err);
    }
  };
}
